import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCurrentUserPermissions } from 'scenes/Permissions/services/getCurrentUserPermissions.service';

export const loadAllCurrentUserPermissions = createAsyncThunk(
  'permissions/loadAllCurrentUserPermissions',
  async (_) => {
    const { projectPermissions, businessPermissions, adminPermissions } =
      await getCurrentUserPermissions();

    return { projectPermissions, businessPermissions, adminPermissions };
  }
);
